export default __webpack_public_path__ + "a77794c5ee99bce3bd2bcc9d5516a84f.svg";